var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{pre:true,attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 28.14 11.46"}},[_c('path',{pre:true,attrs:{"d":"M0,0,3.93,2.3a22,22,0,0,1,7.83,7.84h0a2.67,2.67,0,0,0,4.61,0h0A22,22,0,0,1,24.21,2.3L28.14,0Z","fill":"currentColor"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }